import React from 'react';
import { Navigate } from 'react-router-dom';

import { Painel } from '../Painel';
import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import { Container, Subtitle, Title } from './styles';

// Rota catch-all ("*"): não passa pelo `AuthRoute`, então repete aqui
// a mesma checagem de sessão que ele faz -- sem usuário logado, a URL
// inexistente devolve pro sign-in em vez de tentar montar o `Painel`
// (que depende de dados de usuário/academia já carregados).
const NotFoundPage: React.FC = () => {
  const user = localStorage.getItem('@TrenzoX:user');

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <Painel loading={false}>
      <Container>
        <Icon name="search_off" size={40} color={colors.onSurfaceVariant} />
        <Title>Página não encontrada</Title>
        <Subtitle>
          O endereço que você tentou acessar não existe. Use o menu ao lado
          para continuar navegando.
        </Subtitle>
      </Container>
    </Painel>
  );
};

export { NotFoundPage };
